<script>
	import Visual from './Visual.svelte';
	// import * as d3 from 'd3';
  $: mask = document.querySelector('.mask');
  let x;
  let y;
  let height;
  let image_to_show;

  $: height;

  $: { 
    document.addEventListener('pointermove', (pos) => {
      x = parseInt(pos.clientX / window.innerWidth * 100);
      y = parseInt(pos.clientY / window.innerHeight * 100);
      console.log(pos.clientY, window.innerHeight )
      // mask.style.setProperty('--mouse-x', x + '%');
      // mask.style.setProperty('--mouse-y', y + '%'); 
  });
}


let data = [
  {
    "url": "https://www.bloomberg.com/graphics/2025-youtube-podcast-men-for-trump/?terminal=true",
    "title": "The Second Trump Presidency, Brought To You By Youtubers",
    "img": "youtubebros.png",
    "date": "Jan-25"
  },
  {
    "url": "https://www.bloomberg.com/graphics/2024-us-election-results/markets",
    "title": "Markets Page",
    "img": "markets.png",
    "date": "Nov-24"
  },
  {
    "url": "https://www.bloomberg.com/graphics/2024-nyc-apartment-development-housing-shortage/?terminal=true",
    "title": "New York City Apartment Construction Is Grinding to a Halt",
    "img": "nycapts.png",
    "date": "Jul-24"
  },
 {
    "url": "https://www.bloomberg.com/graphics/2023-wall-street-subprime-car-loans/?terminal=true",
    "title": "How Wall Street Makes Millions Selling Car Loans Customers Can’t Repay",
    "img": "subprime.png",
    "date": "Nov-23"
  },
  {
    "url": "https://www.bloomberg.com/graphics/2023-fema-disaster-relief-fund-extreme-weather-climate-aid/",
    "title": "Climate Disasters Drain US Emergency Fund, Adding to Government Shutdown Risk",
    "img": "fema.png",
    "date": "Sept-23"
  },
  {
    "url": "https://www.bloomberg.com/graphics/2023-global-warming-impacts-data/",
    "title": "Rising Temperatures Are Wreaking Havoc Year-Round",
    "img": "hote.png",
    "date": "Aug-23"
  },
  {
    "url": "https://www.bloomberg.com/graphics/2023-celebrity-beauty-brands-makeup-skincare/",
    "title": "The Golden Era of Celebrity Beauty Brands Is Ending",
    "img": "goldenera.png",
    "date": "March-23"
  },
  {
    "url": "https://www.bloomberg.com/graphics/2022-twitter-birdwatch-community-notes-misinformation-politics/",
    "title": "Twitter’s Fact-Checking System Has a Major Blind Spot: Anything Divisive",
    "img": "2022-community-notes-social-homepage.png",
    "date": "Dec-22"
  },
  {
    "url": "https://www.bloomberg.com/graphics/2022-ukraine-culture-russia-war-map-building-preservation/",
    "title": "How Ukrainians Are Protecting Their Centuries-Old Culture From Putin’s Invasion",
    "img": "2022-ukraine-culture-russia-war-map-building-preservation-homepage.png",
    "date": "Nov-22"
  },
  {
    "url": "https://www.bloomberg.com/graphics/2022-twitch-problem-with-child-predators/",
    "title": "Child Predators Use Twitch to Systematically Track Kids Livestreaming",
    "img": "2022-twitch-child-pred-social_homepage.png",
    "date": "Sep-22"
  },
  {
    "url": "https://www.bloomberg.com/graphics/2022-pakistan-floods-climate-change-loss-damage-cop27/",
    "title": "A New Era of Climate Disasters Revives Calls for Climate Reparations",
    "img": "himalayaglacier.jpeg",
    "date": "Sep-22"
  },
  {
    "url": "https://www.bloomberg.com/graphics/2022-fashion-industry-environmental-impact/",
    "title": "The Global Glut of Clothing Is an Environmental Crisis",
    "img": "2022-fashion-industry-environmental-impact-social_homepage.png",
    "date": "Feb-22"
  },
  {
    "url": "https://www.bloomberg.com/graphics/2021-urban-highways-infrastructure-racism/",
    "title": "What It Looks Like to Reconnect Black Communities Torn Apart by Highways",
    "img": "highway.png",
    "date": "Jul-21"
  },
  {
    "url": "https://www.bloomberg.com/graphics/2020-chess-boom/",
    "title": "‘The Queen’s Gambit’ Chess Boom Moves Online",
    "img": "queens_gambit.png",
    "date": "Dec-20"
  },
  {
    "url": "https://www.bloomberg.com/graphics/2020-suburban-density-election/",
    "title": "How Suburbs Swung the 2020 Election",
    "img": "",
    "date": "Nov-20"
  },
  {
    "url": "https://www.bloomberg.com/graphics/2021-tracking-carbon-emissions-BP-hilcorp/",
    "title": "What Happens When an Oil Giant Walks Away",
    "img": "oil.png",
    "date": "Apr-21"
  },
  {
    "url": "https://projects.fivethirtyeight.com/republicans-democrats-cities/",
    "title": "Where Democrats And Republicans Live In Your City",
    "img": "",
    "date": "May-19"
  },
  {
    "url": "https://fivethirtyeight.com/features/americas-electoral-map-is-changing/",
    "title": "America’s Electoral Map Is Changing",
    "img": "",
    "date": "Dec-18"
  },
  {
    "url": "https://www.bloomberg.com/graphics/2022-plastic-climate-change-pollution-data/",
    "title": "The Climate Impact of Our Insatiable Plastic Addiction",
    "img": "2022-plastic-climate-change-pollution-data-social_homepage.png",
    "date": "Oct-20"
  },
  {
    "url": "https://www.bloomberg.com/graphics/covid-vaccine-tracker-global-distribution/us-vaccine-demographics.html",
    "title": "Half of U.S. States Have Big Racial Vaccine Gaps Heading Into Omicron",
    "img": "",
    "date": "Dec-21"
  },
  {
    "url": "https://www.bloomberg.com/graphics/2021-georgia-unemployment-bias/",
    "title": "Georgia Shows Just How Broken American Unemployment Benefits Are",
    "img": "georgia.png",
    "date": "Sep-20"
  },
  {
    "url": "https://www.bloomberg.com/graphics/2022-biden-student-loan-debt-forgiveness-explainer/",
    "title": "Student Loan",
    "img": "studentloan.png",
    "date": "May-22"
  },
  {
    "url": "  https://www.bloomberg.com/graphics/2021-census-suburbs/",
    "title": "Census Suburbs",
    "img": "suburbs.png",
    "date": "May-22"
  },
  {
    "url": "  https://projects.fivethirtyeight.com/republicans-democrats-cities/",
    "title": "FiveThirtyEight",
    "img": "sub.png",
    "date": "May-22"
  }
];

// $: height = document.querySelector('main').clientHeight;


// $i: mage_to_show = 'pages_14-3';

let images = ['pages_14-3', 'pages_4-13', 'pages_12-5', 'pages_6-11', 'pages_10-7', 'pages_8-9']
let i = 0;

function change() {

  i = i < 5 ? i+1 : 0;
  image_to_show = images[i];
  console.log(i);

  setTimeout(change, 1500);
}

change();

$: console.log(height, x, y);
let links = data.filter(d => {return d.img != ''})
</script>
<!-- <svelte:window bind:scrollHeight={height}/> -->

<svelte:head>
  <link rel="preconnect" href="https://fonts.googleapis.com">
  <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
  <link href="https://fonts.googleapis.com/css2?family=Homemade+Apple&family=Modak&family=Nabla&family=Work+Sans:wght@100&display=swap" rel="stylesheet">
  </svelte:head>
<main bind:clientHeight={height}>
    <div class="top-list">
      <a href="https://twitter.com/rachaeldottle" target="_blank">twitter</a>
      <a href="https://www.instagram.com/rachaelcdottle/?hl=en" target="_blank">ig</a>
      <a href="https://www.bloomberg.com/authors/AU1nEMcaHjc/rachael-dottle" target="_blank">bbg</a>
      <a href="./images/rachaeldottle_resume.pdf" target="_blank">resume</a>
      <span>rachaelcdottle at gmail</span>
    </div>
   <a href="#riso"><div class="zine">
      <img src="./images/zine.png"/>
    </div></a> 

    <div class="para">
      <h1>Rachael Dottle visual journalist</h1>
    </div>
  
    <div class="recent">
      {#each links as link, i}
        <div>
          <a href="{link.url}" target="_blank">
            <img class='frame' src="./images/frame.png" alt="img frame"/>
            <img class="inner" src="./images/{link.img}" alt="img"/></a>
        </div>
        {/each}
    </div>
    <!-- <div class="mask" style="--height: {height}px; --mouse-x: {x}%; --mouse-y: {y}%; height: {height}px;"></div> -->
  <div class="riso" id ="riso">
    <img class='frame' src="./images/frame2.png" alt="img frame"/>
    <img src="./images/{image_to_show}.png"/>
    <!-- <img src="./images/pages_4-13.png"/>
    <img src="./images/pages_12-5.png"/>
    <img src="./images/pages_6-11.png"/>
    <img src="./images/pages_10-7.png"/>
    <img src="./images/pages_8-9.png"/> -->

  </div>
  </main>

  

  <style lang="scss">
    .riso {
      width: 100%;
      // padding-bottom: 50px;
      height: max-content;
      @media (max-width: 900px) {
          width: 100%;
          height: max-content;
        }
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      // background-image: linear-gradient(#4969f5 , #FDDA0D );
      // margin-bottom: 50px;
    
      img {
        margin: 0 auto;
        margin: 20px;
        position: absolute;
        @media (max-width: 900px) {
          width: 85%;
        }
        // margin-bottom: 50px;

      }
      .frame {
        position: relative;
        top: -30px;
        z-index: 100;
        @media (max-width: 900px) {
          // width: 80%;
           width: 100%;
           top: -20px;
          
        }
      }

    }
    .main-wrapper {
      height: max-content;
      padding-top: 30px;
    }
    // @import url('https://fonts.googleapis.com/css2?family=Homemade+Apple&family=Modak&family=Work+Sans:wght@100&display=swap');
   :global(body) {
    background: #4969f5;
   }
   main {
    height: max-content;
    // height: max-content;
    width: 100%;
    top: 0;
    position: absolute;
    // height: max-content;
    @media (max-width: 900px) {
      height: max-content;
    }

   }
    .para {
      font-family: 'Nabla', 'Roboto';
      font-size: 8vh;
      color: orange;
      // animation: animatetop 3s infinite linear;
      // mix-blend-mode: exclusion;
      line-height: 2em;
      text-align: center;
        @media (max-width: 900px) {
             font-size: 10vw; 
      }
      }
      .mask {
      width: 100vw;
      height: --height;
      background-color: rgba(255, 0, 0, 0.5);
      // background-blend-mode: multiply;
    }
   :global( :root) {
    --mouse-x: 50%;
    --mouse-y: 50%;
  }

  @keyframes animatetop {
    0% {
      mix-blend-mode: color-burn;

    }
    50% {
      mix-blend-mode: normal;
    }

    100% {
      mix-blend-mode: color-burn;
    }
  }
  
  :global(body) {
    margin: 0;
    // scrollbar-color: rebeccapurple green;
    // -webkit-scrollbar-color:
    cursor: crosshair;

    // height: 100vh;
    // background-image: url(https://unsplash.it/1920/1080);
    // background-position: center center;
    // background-size: cover;
    // overflow: hidden;
    overflow-x: hidden;
    padding: 0 !important;
    width: 100%;
    @media (max-width: 900px) {
        overflow: auto;
        overflow-x: hidden;
      }
  }
  
  // .mask {
  //   padding: 8px;
  //   width: 100vw;
  //   // height: 100vh;
  //   @media (max-width: 900px) {
  //       // height: 300vh;
  //     }
  //   position: absolute;
  //   z-index: 100;
  //   top:0;
  //   mix-blend-mode: color-burn;
  //   height: 100vh;
  //   // background-color: hsla(0,0%,0%, 0.9);
  //   mask: radial-gradient(
  //     circle at var(--mouse-x) var(--mouse-y),
  //     transparent 150px,
  //     red 500px
  //   );
  //   -webkit-mask: radial-gradient(
  //     circle at var(--mouse-x) var(--mouse-y),
  //     transparent 150px,
  //     red 500px
  //   );
  // }
  
  .top-list {
    position: relative;
    z-index: 500;
    display: flex;
    width: 100%;
    justify-content: space-around;
    margin-top: 40px;
    span {
      color: #FDDA0D;
    }
    a {
      text-decoration: underline;
      color: #FDDA0D;
     
    }
    a:hover {
        color: red;
        transition: 0.5s color;
        cursor: pointer;
      }
  }
  .recent {
    // position: absolute;
    mix-blend-mode: normal;
    position: relative;
    z-index: 600;
    display: flex;
    vertical-align: middle;
    justify-content: center;
    // flex-wrap: nowrap;
    flex-wrap: wrap;
    width: 75%;
    margin: 0 auto;
    color: red;
    @media (max-width: 900px) {
        flex-wrap: wrap;
        width: 100%;
      }
    div {
      width: 18%;
      position: relative;
      margin: 10px;

      @media (max-width: 900px) {
        width: 95%;
        margin-top: 40px;
      }
      .frame {
        position: absolute;
        width: 100%;
      }
      .inner {
        width: 70%;
       margin: 20% 0% 50% 20%;
      }
    }
    div:hover {
      // background-color: red;
      transition: 2s filter ease-in-out;
      filter: drop-shadow(5px 5px 30px yellow);
    }
   
  }

  .zine {
    height: max-content;
    width: max-content;
    mix-blend-mode:exclusion;
    opacity: 70%;
    position: absolute;
  
    top: 5%;
    z-index: 1;
    @media (max-width: 900px) {
       position: relative;
       img {
        width: 300px;
       }
      }
   
      &:hover {
        // z-index: -1000;
        mix-blend-mode: normal;
        opacity: 100%;
        // transition: mix-blend-mode 1s linear;
      }

  }
  </style>